module.exports = __webpack_public_path__ + "img/family-beach-512x170-60.a70123eb.jpg";